// extracted by mini-css-extract-plugin
module.exports = {"root":"rwMrJk","retail":"H_Ol8o","tax":"mqDTc3"};